var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiveawaysActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#FEE5F3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 22H14V30C14 30.5304 14.2107 31.0391 14.5858 31.4142C14.9609 31.7893 15.4696 32 16 32H21V22H15ZM28 22H23V32H28C28.5304 32 29.0391 31.7893 29.4142 31.4142C29.7893 31.0391 30 30.5304 30 30V22H28ZM28.791 17C28.9377 16.5138 29.0082 16.0078 29 15.5C29 13.57 27.43 12 25.5 12C23.878 12 22.795 13.482 22.096 15.085C21.407 13.57 20.269 12 18.5 12C16.57 12 15 13.57 15 15.5C15 16.096 15.079 16.589 15.209 17H12V21H21V19H23V21H32V17H28.791ZM17 15.5C17 14.673 17.673 14 18.5 14C19.388 14 20.214 15.525 20.698 17H18C17.626 17 17 17 17 15.5ZM25.5 14C26.327 14 27 14.673 27 15.5C27 17 26.374 17 26 17H23.523C24.033 15.424 24.774 14 25.5 14Z",
    fill: "#FF3093"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiveawaysActive);
export default __webpack_public_path__ + "static/media/giveawaysActive.8c6bfbcda554d3af9a6479c0d4a7d89d.svg";
export { ForwardRef as ReactComponent };